import { combineReducers } from 'redux';
//import { connectRouter } from 'connected-react-router';
//import { History } from 'history';
import * as uiReducer from './ui.reducer';
import * as loginReducer from './login.reducer';
import * as user from './user.reducer';
import * as dashboard from './dashboard.reducer';
import * as post from './post.reducer';
import * as groups from './usersGroups.reducer';
import * as groupsPermission from './usersGroupsPermissions.reducer';
import * as chat from './chat.reducer';
import * as failedUrls from './failedUrls.reducer';
import * as setting from './setting.reducer';
import * as campaign from './campaign.reducer';
import * as notifications from './notifications.reducer';
import * as directMessage from './direct.message.reducer';
import * as signupCodes from './signupCode.reducer';
const createRootReducer = (history) => combineReducers(Object.assign(
    uiReducer,
    loginReducer,
    user,
    dashboard,
    post,
    groups,
    groupsPermission,
    chat,
    failedUrls,
    setting,
    campaign,
    notifications,
    directMessage,
    signupCodes
));
export default createRootReducer;
